import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatPanel from '../components/chat/ChatPanel';
import api from '../lib/api';

const AskGuide = () => {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    api.get('/chat/config').then((r) => setEnabled(!!r.data?.enabled)).catch(() => setEnabled(false));
  }, []);

  return (
    <div className="App" data-testid="page-ask-guide">
      <Header />
      <main className="bg-cream min-h-screen">
        <section className="max-w-[820px] mx-auto px-6 lg:px-10 py-14">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 eyebrow mb-3"><Sparkles className="w-4 h-4" /> Seeker's Guide</div>
            <h1 className="font-serif-display text-4xl md:text-5xl text-burgundy">Ask the <span className="font-italic-display text-rose-italic">Guide</span></h1>
            <p className="mt-3 text-mahogany/80 max-w-xl mx-auto">A calm companion for meditation, Osho's vision, and finding your way around Osho Universal.</p>
          </div>
          <div className="mt-8">
            {enabled === false ? (
              <div className="text-center text-mahogany/70 rounded-3xl border border-rose/40 bg-white/70 py-16" data-testid="chat-disabled-note">
                The Seeker's Guide is resting at the moment. Please check back soon. 🌸
              </div>
            ) : enabled === true ? (
              <ChatPanel variant="page" />
            ) : null}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AskGuide;
